export const GET_LANGUAGE_FULFILLED = 'GET_LANGUAGE_FULFILLED'
export const UPDATE_SELECTED_LANGUAGE = 'UPDATE_SELECTED_LANGUAGE'
export const GET_LANGUAGE_REQUESTED = 'GET_LANGUAGE_REQUESTED'

export const FETCH_MEMBER_INFO = 'FETCH_MEMBER_INFO'
export const FETCH_MEMBER_INFO_SUCCESS = 'FETCH_MEMBER_INFO_SUCCESS'
export const FETCH_MEMBER_INFO_FAILURE = 'FETCH_MEMBER_INFO_FAILURE'

export const ADD_ACCOUNT_LINK = 'ADD_ACCOUNT_LINK'
export const ADD_ACCOUNT_LINK_SUCCESS = 'ADD_ACCOUNT_LINK_SUCCESS'
export const ADD_ACCOUNT_LINK_FAILURE = 'ADD_ACCOUNT_LINK_FAILURE'

export const FETCH_NOTICES = 'FETCH_NOTICES'
export const FETCH_NOTICES_SUCCESS = 'FETCH_NOTICES_SUCCESS'
export const FETCH_NOTICES_FAILURE = 'FETCH_NOTICES_FAILURE'

export const FETCH_WORKER_NOTICES = 'FETCH_WORKER_NOTICES'
export const FETCH_WORKER_NOTICES_SUCCESS = 'FETCH_WORKER_NOTICES_SUCCESS'
export const FETCH_WORKER_NOTICES_FAILURE = 'FETCH_WORKER_NOTICES_FAILURE'

export const WORKER_NOTICE_ACTION = 'WORKER_NOTICE_ACTION'
export const WORKER_NOTICE_ACTION_SUCCESS = 'WORKER_NOTICE_ACTION_SUCCESS'
export const WORKER_NOTICE_ACTION_FAILURE = 'WORKER_NOTICE_ACTION_FAILURE'

export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS'
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS'
export const FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE'

export const FETCH_BANNERS_LIST = 'FETCH_BANNERS_LIST'
export const FETCH_BANNERS_LIST_SUCCESS = 'FETCH_BANNERS_LIST_SUCCESS'
export const FETCH_BANNERS_LIST_FAILURE = 'FETCH_BANNERS_LIST_FAILURE'

export const AZURE_LOGIN = 'AZURE_LOGIN'
export const AZURE_LOGIN_SUCCESS = 'AZURE_LOGIN_SUCCESS'
export const AZURE_LOGIN_FAILURE = 'AZURE_LOGIN_FAILURE'

export const ACCOUNT_LINKING_DETAILS = 'ACCOUNT_LINKING_DETAILS'
export const ACCOUNT_LINKING_DETAILS_SUCCESS = 'ACCOUNT_LINKING_DETAILS_SUCCESS'
export const ACCOUNT_LINKING_DETAILS_FAILURE = 'ACCOUNT_LINKING_DETAILS_FAILURE'
export const CLEAR_ACCOUNT_LINKING_DETAILS_DATA = 'CLEAR_ACCOUNT_LINKING_DETAILS_DATA'

export const ACCOUNT_SEARCH_DETAILS = 'ACCOUNT_SEARCH_DETAILS'
export const ACCOUNT_SEARCH_DETAILS_SUCCESS = 'ACCOUNT_SEARCH_DETAILS_SUCCESS'
export const ACCOUNT_SEARCH_DETAILS_FAILURE = 'ACCOUNT_SEARCH_DETAILS_FAILURE'
export const CLEAR_ACCOUNT_SEARCH_DETAILS = 'CLEAR_ACCOUNT_SEARCH_DETAILS'

export const ACCOUNT_SEARCH_LINK_DETAILS = 'ACCOUNT_SEARCH_LINK_DETAILS'
export const ACCOUNT_SEARCH_LINK_DETAILS_SUCCESS = 'ACCOUNT_SEARCH_LINK_DETAILS_SUCCESS'
export const ACCOUNT_SEARCH_LINK_DETAILS_FAILURE = 'ACCOUNT_SEARCH_LINK_DETAILS_FAILURE'
export const CLEAR_ACCOUNT_SEARCH_LINK_DETAILS = 'CLEAR_ACCOUNT_SEARCH_LINK_DETAILS'

export const SEND_FEEDBACK = 'SEND_FEEDBACK'
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS'
export const SEND_FEEDBACK_FAILURE = 'SEND_FEEDBACK_FAILURE'

export const AZURE_LOGOUT = 'AZURE_LOGOUT'
export const AZURE_LOGOUT_SUCCESS = 'AZURE_LOGOUT_SUCCESS'
export const AZURE_LOGOUT_FAILURE = 'AZURE_LOGOUT_FAILURE'

export const GET_LANGUAGE_FAILED = 'GET_LANGUAGE_FAILED'

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'

export const GET_FEEDBACK = 'GET_FEEDBACK'
export const HIDE_FEEDBACK = 'HIDE_FEEDBACK'

export const UPDATE_COMM_PREF = 'UPDATE_COMM_PREF'
export const UPDATE_COMM_PREF_SUCCESS = 'UPDATE_COMM_PREF_SUCCESS'
export const UPDATE_COMM_PREF_FAILURE = 'UPDATE_COMM_PREF_FAILURE'
export const UPDATE_COMM_PREF_RESET = 'UPDATE_COMM_PREF_RESET'
export const SEARCH_MEMBERS_ACCESS = 'SEARCH_MEMBERS_ACCESS'
export const SEARCH_MEMBERS_ACCESS_SUCCESS = 'SEARCH_MEMBERS_ACCESS_SUCCESS'
export const SEARCH_MEMBERS_ACCESS_FAILURE = 'SEARCH_MEMBERS_ACCESS_FAILURE'

export const MEMBER_ACCESS_RESRICT = 'MEMBER_ACCESS_RESRICT'
export const MEMBER_ACCESS_RESRICT_SUCCESS = 'MEMBER_ACCESS_RESRICT_SUCCESS'
export const MEMBER_ACCESS_RESRICT_FAILURE = 'SMEMBER_ACCESS_RESRICT_FAILURE'

export const MEMBER_ACCESS_UNRESRICT = 'MEMBER_ACCESS_UNRESRICT'
export const MEMBER_ACCESS_UNRESRICT_SUCCESS = 'MEMBER_ACCESS_UNRESRICT_SUCCESS'
export const MEMBER_ACCESS_UNRESRICT_FAILURE = 'SMEMBER_ACCESS_UNRESRICT_FAILURE'

export const GET_BANNERS = 'GET_BANNERS'
export const GET_BANNERS_SUCCESS = 'GET_BANNERS_SUCCESS'
export const GET_BANNERS_FAILURE = 'GET_BANNERS_FAILURE'

export const UPDATE_BANNER = 'UPDATE_BANNER'
export const UPDATE_BANNER_SUCCESS = 'UPDATE_BANNER_SUCCESS'
export const UPDATE_BANNER_FAILURE = 'UPDATE_BANNER_FAILURE'
export const UPDATE_BANNER_RESET = 'UPDATE_BANNER_RESET'

export const SAVE_BANNER = 'SAVE_BANNER'
export const SAVE_BANNER_SUCCESS = 'SAVE_BANNER_SUCCESS'
export const SAVE_BANNER_FAILURE = 'SAVE_BANNER_FAILURE'
export const SAVE_BANNER_RESET = 'SAVE_BANNER_RESET'

export const UPDATE_BANNER_PRIORITY = 'UPDATE_BANNER_PRIORITY'
export const UPDATE_BANNER_PRIORITY_SUCCESS = 'UPDATE_BANNER_PRIORITY_SUCCESS'
export const UPDATE_BANNER_PRIORITY_FAILURE = 'UPDATE_BANNER_PRIORITY_FAILURE'
export const UPDATE_BANNER_PRIORITY_RESET = 'UPDATE_BANNER_PRIORITY_RESET'

export const CLEAR_SESSION = 'CLEAR_SESSION'
export const CLEAR_SESSION_SUCCESS = 'CLEAR_SESSION_SUCCESS'
export const CLEAR_SESSION_FAILURE = 'CLEAR_SESSION_FAILURE'
